import KPIValueTargetCard from "../KPIValue/KPIValueTargetCard";
import TaskSwimLanes from "../../components/tasks/TaskSwimLanes";
import React, {useMemo} from "react";
import {useListKpiTargetsQuery} from "../../apis/kpiApi";
import {useUserProfileQuery} from "../../apis/authenticationApi";
import {useSelector} from "react-redux";

const Dashboard = () => {
    const {data, isFetching} = useListKpiTargetsQuery();
    const {data: userProfile} = useUserProfileQuery();
    const selectedYear = useSelector(state => state.kpi.selectedYear);

    return useMemo(() => {
        const sortedArray = [...(data || [])]
            .filter(kpi => kpi.responsible === userProfile?.company?.account && kpi.year === selectedYear && (kpi.timeFrame === 'Annual' || kpi.timeFrame === 'Quarter') && (kpi.type === 'Benchmark' || kpi.type === 'Target'))
            .sort((targetA, targetB) => targetB.weight - targetA.weight);

        if(isFetching)
            return (<></>);

        return (
            <>
                <div className="kpi-values">
                    {sortedArray.map(target => (<KPIValueTargetCard key={target.id} target={target} path="" showScoreboardTag={true} /> ))}
                </div>
                <TaskSwimLanes />
            </>
        )
    }, [data, userProfile, isFetching, selectedYear]);
}

export default Dashboard;
